/**
 * Sorts fields based on the isOverridden property, with overridden fields appearing first.
 *
 * @param a First field object containing an isOverridden property
 * @param b Second field object containing an isOverridden property
 * @returns Sorting value (-1, 0, 1)
 */
export function sortByOverridden<T extends { field: { isOverridden: boolean } }>(
  a: T,
  b: T
): number {
  const aOverridden = a.field.isOverridden ? 1 : 0
  const bOverridden = b.field.isOverridden ? 1 : 0
  return bOverridden - aOverridden
}
